module.exports = __webpack_public_path__ + "static/img/active8.b3c8bdfd.png";